"use client";
import React, { useEffect, useRef, useState } from 'react';
import otp from "./otp.module.css";
import { useRouter, useSearchParams } from 'next/navigation';
import { timer } from '../utils/timer';
import { useAuthStore } from '../store/authstore';
import { useFavoriteStore, useToastStore } from '../store/localapi';
import { syncfav } from '../utils/syncfav';
import { fetchWithLoader } from '../utils/api';
import tohash from '../utils/tohash';

export default function VerifyOtpComponent() {
  const [otpValue, setOtpValue] = useState<string[]>([]);
  const [inputValues, setInputValues] = useState<string[]>(Array(4).fill(''));
  const [otpfor, setOtpFor] = useState<string>('/');
  const [otpVerified, setOtpVerified] = useState<number | null>(null);
  const [remaining, setRemaining] = useState<number>(30);

  const logout = useAuthStore((state) => state.logout);
  const login = useAuthStore((state) => state.login);
  const user = useAuthStore((state) => state.user);
  const searchParams = useSearchParams();
  const router = useRouter();
  const timerRef = useRef<ReturnType<typeof timer> | null>(null);

  const { showToast } = useToastStore()
  const favorites = useFavoriteStore((state) => state.favorites)
  const addfav = useFavoriteStore((state) => state.addFavorite)

  const syncdata = async (userId: string) => {
    const res = await syncfav(favorites, userId)
    if (res && res.length) {
      const existingIds = new Set(Object.keys(useFavoriteStore.getState().favorites));
      // eslint-disable-next-line
      res.forEach((d: any) => {
        if (!existingIds.has(String(d.d_id))) {
          addfav(d);
          existingIds.add(String(d.d_id));
        }
      });
    }
  }

  // Helper to clear OTP inputs and focus first input
  const clearOtpInputs = () => {
    setInputValues(Array(4).fill(''));
    const inputs = document.querySelectorAll('input[type="text"]') as NodeListOf<HTMLInputElement>;
    if (inputs && inputs.length > 0) {
      inputs[0].focus();
    }
  };

  useEffect(() => {
    if (searchParams) {
      const arr = ['deleteacc', 'emailauth', 'signup', 'forget']
      searchParams.forEach((value, key) => {
        if (arr.includes(key)) {
          setOtpFor(key);
        } else {
          router.replace('/');
        }
      });
      const hash = sessionStorage.getItem('_hash');
      setOtpValue(hash ? Array.from(hash.slice(5, 9)) : []);
    } else {
      router.push('/');
    }
  }, [searchParams, router, inputValues]);


  useEffect(() => {
    timerRef.current = timer(30, setRemaining);
    return () => {
      // eslint-disable-next-line
      if (timerRef.current && typeof (timerRef.current as any).stop === "function") {
        (timerRef.current as { stop: () => void }).stop()
      }
    };
  }, []);

  // useEffect(() => { remaining == 0 && sessionStorage.removeItem('_hash') }, [remaining])


  const getUser = (uid: string) => {
    fetch('https://dramasstory.com/web/user_profile.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: uid }),
    }).then(res => res.json()).then(data => {
      login(data.data.Data);
      sessionStorage.removeItem('_hash');
      setOtpVerified(1);
      syncdata(data.data.Data.user_id)
      // console.log("OTP Matched!");
      showToast("OTP Matched!", "success");
      router.replace('/')
      return;
    }).catch(err => {
      console.log(err)
    })
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const { value } = e.target;
    const textinput = document.querySelectorAll('input[type="text"]') as NodeListOf<HTMLInputElement>;
    if (!/^[0-9]+$/.test(value)) {
      textinput[index].value = "";
      return;
    }
    // stop moving to next input if previous input is empty (except for 1st input)
    if (index > 0 && inputValues[index - 1] === "") {
      return;
    }

    if (/^\d$/.test(value)) {
      if (index < 3) {
        const nextInput = textinput[index + 1] as HTMLInputElement;
        if (nextInput) {
          nextInput.disabled = false;
          nextInput.focus();
        }
      }
    } else if (value === "") {
      if (inputValues[index] !== "") {
        setInputValues(prev => {
          const newValues = [...prev];
          newValues[index] = "";
          return newValues;
        });
      } else if (index > 0) {
        const prevInput = textinput[index - 1] as HTMLInputElement;
        if (prevInput) {
          prevInput.focus();
        }
      }
    }

    setInputValues(prev => {
      const newValues = [...prev];
      newValues[index] = value;
      return newValues;
    });

    const updatedValues = [...inputValues];
    updatedValues[index] = value;
    const enteredOtp = updatedValues.join('');
    if (otpValue.join('') === enteredOtp) {
      if (otpfor === 'deleteacc') {
        const userId = searchParams.get('deleteacc')?.replace('47cab1f3c8d2a', '');//47cab1f3c8d2a
        if (userId) {
          fetchWithLoader('delete_verify_otp.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: userId, otp: enteredOtp }),
          }).then(res => res.json()).then(data => {
            if (data?.data.ErrorMessage === "OTP match Successfully") {
              showToast("Account deleted successfully", "success");
              sessionStorage.removeItem('_hash');
              logout();
              router.push(`/login/?deleteacc=${userId}`)
            } else {
              setOtpVerified(0);
              showToast("OTP didn't match. Please try again.", "error");
            }
          });
        }
        return
      } else if (otpfor === "emailauth") {
        fetch('https://dramasstory.com/web/user_otp_auth.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_email: searchParams.get('emailauth') }),
        }).then(res => res.json()).then(data => {
          if (data?.data.ErrorMessage === "Email Verified Successfully" || data?.data.ErrorCode === 0) {
            const id = localStorage.getItem('_id')!
            getUser(id);
          } else {
            setOtpVerified(0);
            showToast("OTP didn't match. Please try again.", "error");
          }
        })
        return
      } else if (otpfor === 'signup') {
        fetch('https://dramasstory.com/web/user_otp_auth.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_email: searchParams.get('signup') }),
        }).then(res => res.json()).then(data => {
          if (data?.data.ErrorMessage === "Email Verified Successfully" || data?.data.ErrorCode === 0) {
            const id = localStorage.getItem('_id')!
            getUser(id);
            setTimeout(() => {
              showToast("Signed up successfully.", "success");
            }, 50);
          } else {
            setOtpVerified(0);
            showToast("OTP didn't match. Please try again.", "error");
            // clearOtpInputs();
          }
        })
      } else if (otpfor === 'forget') {
        router.push(`/newpassword?email=${searchParams.get('forget')}`);
      } else {
        showToast("Unknown OTP action! Please try again", "error");
      }
    } else if (otpValue.join('') !== enteredOtp && enteredOtp.length === otpValue.length) {
      setOtpVerified(0);
      // logout();
      showToast("OTP didn't match. Please try again.", "error");
      // console.log("OTP does not match.");
      // clearOtpInputs();
    } else if (otpValue.length === 0) {
      setOtpVerified(3);
    }
  };

  // Backspace handling
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, idx: number) => {
    if (e.key === "Backspace") {
      if (inputValues[idx] === "" && idx > 0) {
        const prevInput = document.querySelectorAll('input[type="text"]')[idx - 1] as HTMLInputElement;
        prevInput?.focus();
        setInputValues(prev => {
          const newValues = [...prev];
          newValues[idx - 1] = "";
          return newValues;
        });
      } else if (inputValues[idx] !== "") {
        setInputValues(prev => {
          const newValues = [...prev];
          newValues[idx] = "";
          return newValues;
        });
      }
    }
  }


  const handleResend = async () => {
    // Clear current inputs when user requests resend
    clearOtpInputs();
    let URL = "";
    let OBJ = {}
    if (otpfor == "forget") {
      URL = "drama_forgotpass.php";
      OBJ = { user_email: searchParams.get('forget') };
    } else if (otpfor == "emailauth" || otpfor == "signup") {
      URL = "drama_otp_resend.php";
      OBJ = { user_email: searchParams.get('emailauth') || searchParams.get('signup') };
    } else if (otpfor == "deleteacc") {
      if (user) {
        URL = "delete_user_otp.php";
        OBJ = { user_id: user.user_id };
      }
    }

    try {
      await fetchWithLoader(URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(OBJ)
      }).then(response => response.json()).then(data => {
        if (data?.data?.Data?.otp !== "" || data?.data?.data?.Otp !== "") {
          const otp = data?.data?.Data?.otp || data?.data?.data?.Otp;
          const hash = tohash(otp.toString());
          const final = `${hash?.slice(0, 5)}${otp}${hash?.slice(5)}`;
          sessionStorage.setItem('_hash', `${final}`);
          showToast("OTP sent to your email", "success")
          timerRef.current = timer(30, setRemaining);
        }
      })
    } catch (error) {
      console.log(error)
      showToast("Failed to send OTP. Please try again later.", "error")
    }

  }

  return (
    <div className="setHight">
      <div className={`${otp.signupreset} signUpSec`}>
        <div className="container">
          <div className="signupForm">
            <form onSubmit={(e) => e.preventDefault()}>

              <div className={"titcenter"}>
                <h2 className={"heaing"}>Verify OTP</h2>
                <p className={"register"}>Enter the OTP sent to your registered email id
                  <span className={otp.delaccContent}> to delete your DramaFlicks account</span>
                </p>
              </div>
              <div className={otp.otpfieldList}>
                {inputValues.map((val, idx) => (
                  <div className={otp.otpfield} key={idx}>
                    <input
                      type="text"
                      value={val}
                      maxLength={1}
                      autoFocus={idx === 0}
                      tabIndex={idx + 1}
                      disabled={idx > 0 && inputValues[idx - 1] === ""}
                      onChange={(e) => handleInputChange(e, idx)}
                      onKeyDown={(e) => { handleKeyDown(e, idx) }}
                    />
                  </div>
                ))}
              </div>
              <div className={otp.otpfieldListError} style={{ minHeight: "20px" }}>
                {otpVerified === 1 && <>
                  <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#78A75A"><path d="m429-336 238-237-51-51-187 186-85-84-51 51 136 135Zm51 240q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
                  </svg>
                  <span className={otp.verified}>OTP Successfully Verified</span></>}
                {otpVerified === 0 && <><svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#e21220"><path d="M479.79-288q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM444-432h72v-240h-72v240Zm36.28 336Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" /></svg>
                  <span className={otp.dontmatch}>OTP didn&#39;t match</span>
                </>}
                {otpVerified === 3 && <><svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#e21220"><path d="M479.79-288q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM444-432h72v-240h-72v240Zm36.28 336Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" /></svg>
                  <span className={otp.dontmatch}>OTP expired! try Again</span>
                </>}
              </div>
              <div className={otp.Delbtn}>
                <button type='submit' value="submit" className="commonBtn">Delete</button>
              </div>
              <p className={otp.resendotp}>
                Didn&#39;t receive OTP?
                {remaining <= 0 ? <span style={{ cursor: "pointer", color: 'red', textDecoration: 'underline', marginLeft: '3px' }} onClick={handleResend}>Resend</span> : <span className={otp.resenTime}><span> Resend OTP in</span> {remaining} sec</span>}
              </p>
              <p className={otp.resendotpSpam}>
                In case you don&#39;t receive the mail, Please check your spam folder
              </p>
              {/* <div className="loginBtn">
                <button type='submit' value='' className="commonBtn">Verified</button>
              </div> */}

            </form>
          </div>
        </div>
      </div>
    </div>
  )
}



